/**
 * The status vocabularies. These are THE contract: identical values are used in
 * the database enums (db/schema.sql), in API responses, and in the dashboard.
 * TECHNICAL_PLAN.md §9.1 "Status vocabulary".
 *
 * Conflating "not yet tried" with "tried and will retry" is how invoices get
 * silently stranded past the 30-day cliff, so these five stay distinct.
 */
/** `pending` exists only mid-request; only `retrying` is ever swept. */
export const INVOICE_STATUSES = ["pending", "confirmed", "retrying", "failed", "expired"];
/** Drives retry eligibility. Only `transient` is ever retried — see §9.1. */
export const FISCAL_ERROR_CLASSES = ["transient", "validation", "certificate"];
/** A device cannot fiscalize until the Tax Administration assigns its ISU number (§5.7). */
export const ISU_STATUSES = ["pending", "assigned", "mismatch"];
/**
 * The level a receipt number increments at — Croatia's `<OznSlijed>`.
 *
 * `premises` is `P`, `device` is `N`. Spec §2.2.1 permits only `P` at a
 * self-service device; an attended receipt may use either, and whichever is
 * declared has to be the one the numbers were actually allocated under.
 */
export const RECEIPT_NUMBER_SCOPES = ["premises", "device"];
export const USER_ROLES = ["owner", "admin", "operator", "viewer"];
export const ENTITY_STATUSES = ["active", "suspended", "archived"];
/** test = cistest.apis-it.hr + demo certs; live = cis.porezna-uprava.hr + real certs. */
export const FISCAL_MODES = ["test", "live"];
/**
 * Payment methods. The schema permits the superset including `T`; the Croatian
 * unattended validator rejects `T` because spec §2.2.1 allows only G/K/O at a
 * self-service device. `O` covers mixed payment.
 */
export const PAYMENT_METHODS = ["G", "K", "O", "T"];
export const UNATTENDED_PAYMENT_METHODS = ["G", "K", "O"];
/** Terminal statuses never transition again. */
export const TERMINAL_STATUSES = ["confirmed", "expired"];
export function isTerminal(status) {
    return TERMINAL_STATUSES.includes(status);
}
/** Only rows in this state are picked up by the retry sweep (§9.2). */
export function isSweepable(status, errorClass) {
    return status === "retrying" && errorClass === "transient";
}
//# sourceMappingURL=vocabulary.js.map